import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import categoryServices from "../../services/categories";
import { formattedCategories } from "../../utils/functions";
import orderServices from "../../services/orders";

const initialState = {
    auth: {},
    categories: {
        loading: false,
        data: [],
    },
    progressOrder: {
        loading: false,
        data: [],
    },
};

export const getProgressOrders = createAsyncThunk(
    "orders/getProgressOrders",
    () => {
        return orderServices.getProgressOrders().then(res => res.data?.data);
    }
);
export const getCategories = createAsyncThunk(
    "categories/getCategories",
    () => {
        return categoryServices.getAllCategories().then(async res => {
            if (res.data.last_page > 1) {
                const pagesArray = Array(res.data.lastKey).keys();
                const all = await Promise.all(
                    pagesArray.map(p => {
                        return categoryServices.getAllCategories(p + 1);
                    })
                );
                const mergeData = all.map(c => c.data.data).flat(1);
                return formattedCategories(mergeData);
            } else {
                return formattedCategories(res.data.data);
            }
        });
    }
);
const configSlicer = createSlice({
    name: "config",
    initialState,
    reducers: {
        setAuth: (state, action) => {
            state.auth = action.payload;
            window.localStorage.setItem(
                "dc-auth",
                JSON.stringify(action.payload)
            );
        },
        setCategories: (state, action) => {
            state.categories.data = action.payload;
        },
        setProgressOrders: (state, action) => {
            state.progressOrder.data = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getCategories.pending, state => {
            state.categories.loading = true;
            state.categories.data = [];
        });
        builder.addCase(getCategories.fulfilled, (state, action) => {
            state.categories.loading = false;
            state.categories.data = action.payload;
        });
        builder.addCase(getCategories.rejected, state => {
            state.categories.loading = false;
            state.categories.data = [];
        });
        builder.addCase(getProgressOrders.pending, state => {
            state.progressOrder.loading = true;
            state.progressOrder.data = [];
        });
        builder.addCase(getProgressOrders.fulfilled, (state, action) => {
            state.progressOrder.loading = false;
            state.progressOrder.data = action.payload;
        });
        builder.addCase(getProgressOrders.rejected, state => {
            state.progressOrder.loading = false;
            state.progressOrder.data = [];
        });
    },
});

export const { setAuth, setCategories, setProgressOrders } =
    configSlicer.actions;

export default configSlicer.reducer;
